<template>
    <tr>
        <td>{{ vendor.name }}</td>
        <td>
            <div v-if="order.placed_at">
                {{ order.placed_at | date }}
            </div>
            <em v-else>
                &ndash;
            </em>
        </td>
        <td class="text-right">{{ orderItem.quantity | numberFormat }}</td>
        <td>
            {{ orderStatuses[order.status] }}
        </td>
        <td class="text-right">
            <a :href="`/orders/${order.id}`" target="_blank" class="btn btn-xs btn-default">
                <i class="fa fa-search"></i>
                View
            </a>
        </td>
    </tr>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: ['orderItem'],
    computed: {
        ...mapState('data', {
            order(state) { return state.orders.byId[this.orderItem.order]; },
            vendor(state) { return this.order && state.vendors.byId[this.order.vendor]; },
            orderStatuses(state) { return state.orders.statuses; },
        }),
    },
};
</script>
